export const categories = [
  {
    id: '1',
    name: 'Soloists',
    slug: 'soloists',
    description: 'Individual artists who fill the stage with their voice and presence',
    icon: 'ri-user-voice-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=elegant%20solo%20musician%20performing%20on%20stage%20with%20warm%20amber%20lighting%2C%20professional%20concert%20atmosphere%2C%20acoustic%20guitar%20or%20piano%2C%20intimate%20venue%2C%20soft%20bokeh%20background%2C%20high%20quality%20photography%2C%20dark%20background%20with%20golden%20highlights%2C%20Las%20Vegas%20style%20ambiance&width=800&height=600&seq=1&orientation=landscape',
  },
  {
    id: '2',
    name: 'Duos',
    slug: 'duos',
    description: 'Two artists who create perfect harmonies for intimate events',
    icon: 'ri-group-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=musical%20duo%20performing%20on%20elegant%20stage%2C%20two%20musicians%20with%20guitar%20and%20violin%2C%20warm%20stage%20lighting%2C%20intimate%20concert%20setting%2C%20professional%20photography%2C%20dark%20background%20with%20golden%20amber%20spotlights%2C%20sophisticated%20atmosphere%2C%20Las%20Vegas%20lounge%20style&width=800&height=600&seq=2&orientation=landscape',
  },
  {
    id: '3',
    name: 'Trios',
    slug: 'trios',
    description: 'Three voices and instruments that bring any celebration to life',
    icon: 'ri-team-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=trio%20of%20musicians%20performing%20on%20elegant%20stage%2C%20three%20performers%20with%20guitar%20bass%20and%20vocals%2C%20warm%20amber%20lighting%2C%20professional%20concert%20atmosphere%2C%20dark%20background%20with%20golden%20highlights%2C%20sophisticated%20jazz%20lounge%2C%20Las%20Vegas%20entertainment%20style&width=800&height=600&seq=3&orientation=landscape',
  },
  {
    id: '4',
    name: 'Quartets',
    slug: 'quartets',
    description: 'Formations of four artists for high-level events',
    icon: 'ri-community-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=quartet%20of%20musicians%20performing%20on%20grand%20stage%2C%20four%20artists%20with%20string%20instruments%2C%20elegant%20concert%20lighting%2C%20dark%20background%20with%20golden%20spotlights%2C%20professional%20photography%2C%20sophisticated%20atmosphere%2C%20Las%20Vegas%20ballroom%20style&width=800&height=600&seq=4&orientation=landscape',
  },
  {
    id: '5',
    name: 'Quintets',
    slug: 'quintets',
    description: 'Five talents that create a complete musical experience',
    icon: 'ri-star-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=quintet%20band%20performing%20on%20elegant%20stage%2C%20five%20musicians%20with%20brass%20and%20string%20instruments%2C%20warm%20golden%20lighting%2C%20professional%20concert%20atmosphere%2C%20dark%20background%20with%20amber%20highlights%2C%20sophisticated%20Las%20Vegas%20venue%20style&width=800&height=600&seq=5&orientation=landscape',
  },
  {
    id: '6',
    name: 'Sextets',
    slug: 'sextets',
    description: 'Six artists for a memorable musical production',
    icon: 'ri-music-2-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=sextet%20band%20performing%20on%20grand%20stage%2C%20six%20musicians%20with%20brass%20section%20and%20rhythm%2C%20warm%20golden%20lighting%2C%20professional%20concert%20atmosphere%2C%20dark%20background%20with%20amber%20highlights%2C%20elegant%20Las%20Vegas%20ballroom%20style&width=800&height=600&seq=6&orientation=landscape',
  },
  {
    id: '7',
    name: 'Full Bands',
    slug: 'bands',
    description: 'Complete bands that transform any event into a concert',
    icon: 'ri-music-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=full%20band%20performing%20on%20Las%20Vegas%20concert%20stage%2C%20large%20ensemble%20with%20drums%20guitar%20bass%20keyboards%20and%20vocals%2C%20dramatic%20stage%20lighting%20with%20amber%20and%20gold%2C%20professional%20photography%2C%20dark%20background%20with%20spectacular%20concert%20lights%2C%20high%20energy%20performance&width=800&height=600&seq=7&orientation=landscape',
  },
];

export const eventTypes = [
  {
    id: '1',
    name: 'Weddings',
    slug: 'weddings',
    description: 'Perfect music for the most special day',
    imageUrl: 'https://readdy.ai/api/search-image?query=elegant%20wedding%20reception%20with%20live%20band%20performing%2C%20warm%20candlelight%20and%20string%20lights%2C%20romantic%20atmosphere%2C%20soft%20golden%20lighting%2C%20professional%20photography%2C%20dark%20background%20with%20bokeh%2C%20sophisticated%20Las%20Vegas%20venue%2C%20dancing%20guests%2C%20intimate%20celebration&width=600&height=600&seq=8&orientation=squarish',
  },
  {
    id: '2',
    name: 'Corporate Events',
    slug: 'corporate',
    description: 'Professional entertainment for business events',
    imageUrl: 'https://readdy.ai/api/search-image?query=corporate%20gala%20event%20with%20live%20band%20performing%20on%20stage%2C%20elegant%20ballroom%20setting%2C%20warm%20golden%20lighting%2C%20professionals%20in%20formal%20attire%2C%20sophisticated%20atmosphere%2C%20dark%20background%20with%20amber%20highlights%2C%20Las%20Vegas%20conference%20center%20style%2C%20professional%20photography&width=600&height=600&seq=9&orientation=squarish',
  },
  {
    id: '3',
    name: 'Private Parties',
    slug: 'private',
    description: 'The best music for exclusive celebrations',
    imageUrl: 'https://readdy.ai/api/search-image?query=private%20party%20with%20live%20music%20performance%2C%20elegant%20home%20or%20venue%20setting%2C%20warm%20ambient%20lighting%2C%20guests%20enjoying%20music%2C%20sophisticated%20intimate%20atmosphere%2C%20dark%20background%20with%20golden%20bokeh%2C%20professional%20photography%2C%20Las%20Vegas%20exclusive%20party%20vibe&width=600&height=600&seq=10&orientation=squarish',
  },
  {
    id: '4',
    name: 'Galas',
    slug: 'galas',
    description: 'Luxury artists for high-class events',
    imageUrl: 'https://readdy.ai/api/search-image?query=luxury%20gala%20event%20with%20live%20orchestra%20performing%20on%20grand%20stage%2C%20elegant%20ballroom%20with%20chandeliers%2C%20formal%20attendees%2C%20warm%20golden%20lighting%2C%20sophisticated%20atmosphere%2C%20dark%20background%20with%20amber%20highlights%2C%20Las%20Vegas%20luxury%20venue%20style%2C%20professional%20photography&width=600&height=600&seq=11&orientation=squarish',
  },
  {
    id: '5',
    name: 'Receptions',
    slug: 'receptions',
    description: 'Elegant music to welcome your guests',
    imageUrl: 'https://readdy.ai/api/search-image?query=elegant%20reception%20with%20live%20jazz%20band%20performing%2C%20guests%20mingling%20with%20champagne%2C%20warm%20ambient%20lighting%2C%20sophisticated%20venue%2C%20dark%20background%20with%20golden%20bokeh%2C%20professional%20photography%2C%20Las%20Vegas%20lounge%20style%2C%20intimate%20atmosphere&width=600&height=600&seq=12&orientation=squarish',
  },
  {
    id: '6',
    name: 'Networking',
    slug: 'networking',
    description: 'Pleasant sound that facilitates connections',
    imageUrl: 'https://readdy.ai/api/search-image?query=business%20networking%20event%20with%20ambient%20live%20music%2C%20professionals%20conversing%20in%20elegant%20venue%2C%20soft%20background%20music%2C%20warm%20lighting%2C%20sophisticated%20atmosphere%2C%20dark%20background%20with%20golden%20bokeh%2C%20professional%20photography%2C%20Las%20Vegas%20business%20event%20style&width=600&height=600&seq=13&orientation=squarish',
  },
  {
    id: '7',
    name: 'Special Celebrations',
    slug: 'celebrations',
    description: 'The perfect talent for unforgettable moments',
    imageUrl: 'https://readdy.ai/api/search-image?query=special%20celebration%20event%20with%20live%20band%20performing%2C%20confetti%20and%20warm%20lights%2C%20joyful%20atmosphere%2C%20elegant%20venue%2C%20dark%20background%20with%20golden%20and%20amber%20highlights%2C%20professional%20photography%2C%20Las%20Vegas%20celebration%20style%2C%20memorable%20moment&width=600&height=600&seq=14&orientation=squarish',
  },
];

export const featuredArtists = [
  {
    id: '1',
    name: 'Marco Valencia',
    category: 'Soloist',
    genre: 'Jazz & Bossa Nova',
    bio: 'Vocalist and guitarist with over 15 years of experience on the most exclusive stages in Las Vegas. His warm voice transforms any event into an intimate and memorable experience.',
    imageUrl: 'https://readdy.ai/api/search-image?query=professional%20male%20singer%20performing%20solo%20with%20acoustic%20guitar%2C%20warm%20stage%20lighting%2C%20elegant%20venue%2C%20dark%20background%20with%20golden%20bokeh%2C%20professional%20portrait%20photography%2C%20sophisticated%20Las%20Vegas%20artist%2C%20casual%20elegant%20attire%2C%20intimate%20atmosphere&width=400&height=400&seq=15&orientation=squarish',
    avatarUrl: 'https://readdy.ai/api/search-image?query=professional%20male%20musician%20portrait%2C%20warm%20lighting%2C%20dark%20background%2C%20elegant%20casual%20attire%2C%20confident%20expression%2C%20headshot%20style%2C%20Las%20Vegas%20artist%2C%20amber%20golden%20highlights%2C%20professional%20photography&width=200&height=200&seq=16&orientation=squarish',
    featured: true,
    eventTypes: ['Weddings', 'Receptions', 'Private Parties'],
    phone: '+1 (702) 555-0101',
    email: 'marco@valenciamusic.com',
    website: 'https://marco valencia.com',
    social: {
      instagram: '@marcovalencia',
      facebook: 'Marco Valencia Music',
      youtube: 'Marco Valencia',
    },
  },
  {
    id: '2',
    name: 'Duo Aurora',
    category: 'Duo',
    genre: 'Acoustic Pop',
    bio: "Elena and David's voices blend to create a unique atmosphere. They have played at over 200 corporate events and weddings in Las Vegas and the Reno area.",
    imageUrl: 'https://readdy.ai/api/search-image?query=musical%20duo%20male%20and%20female%20performers%20on%20stage%2C%20acoustic%20guitar%20and%20vocals%2C%20warm%20stage%20lighting%2C%20elegant%20venue%2C%20dark%20background%20with%20golden%20bokeh%2C%20professional%20photography%2C%20sophisticated%20Las%20Vegas%20entertainment%2C%20intimate%20atmosphere&width=400&height=400&seq=17&orientation=squarish',
    avatarUrl: 'https://readdy.ai/api/search-image?query=two%20musicians%20duo%20portrait%2C%20warm%20lighting%2C%20dark%20background%2C%20elegant%20casual%20attire%2C%20professional%20headshot%2C%20Las%20Vegas%20artists%2C%20amber%20golden%20highlights%2C%20professional%20photography%2C%20confident%20expressions&width=200&height=200&seq=18&orientation=squarish',
    featured: true,
    eventTypes: ['Weddings', 'Corporate Events', 'Receptions'],
    phone: '+1 (702) 555-0202',
    email: 'duoaurora@vegas.com',
    website: 'https://duo aurora.com',
    social: {
      instagram: '@duoaurora',
      facebook: 'Duo Aurora',
      youtube: 'Duo Aurora Official',
    },
  },
  {
    id: '3',
    name: 'Las Vegas Swing Trio',
    category: 'Trio',
    genre: 'Jazz & Swing',
    bio: 'Three jazz masters who bring the classic sound of Las Vegas halls to modern events. Piano, double bass, and saxophone in perfect harmony.',
    imageUrl: 'https://readdy.ai/api/search-image?query=jazz%20trio%20performing%20on%20elegant%20stage%2C%20piano%20bass%20and%20saxophone%2C%20warm%20golden%20lighting%2C%20professional%20concert%20atmosphere%2C%20dark%20background%20with%20amber%20highlights%2C%20sophisticated%20Las%20Vegas%20lounge%20style%2C%20professional%20photography%2C%20vintage%20elegance&width=400&height=400&seq=19&orientation=squarish',
    avatarUrl: 'https://readdy.ai/api/search-image?query=three%20jazz%20musicians%20portrait%2C%20warm%20lighting%2C%20dark%20background%2C%20elegant%20suits%2C%20professional%20headshot%2C%20Las%20Vegas%20artists%2C%20amber%20golden%20highlights%2C%20professional%20photography%2C%20sophisticated%20expressions&width=200&height=200&seq=20&orientation=squarish',
    featured: true,
    eventTypes: ['Galas', 'Corporate Events', 'Receptions'],
    phone: '+1 (702) 555-0303',
    email: 'info@vegasswing.com',
    website: 'https://vegas swing.com',
    social: {
      instagram: '@vegasswingtrio',
      facebook: 'Las Vegas Swing Trio',
      youtube: 'Las Vegas Swing',
    },
  },
  {
    id: '4',
    name: 'Elite Quartet',
    category: 'Quartet',
    genre: 'Classical & Pop',
    bio: 'String quartet that has accompanied the most prestigious events in Las Vegas. From Mozart classics to today\'s hits, their versatility is unmatched.',
    imageUrl: 'https://readdy.ai/api/search-image?query=string%20quartet%20performing%20on%20elegant%20stage%2C%20four%20musicians%20with%20violins%20and%20cello%2C%20warm%20golden%20lighting%2C%20professional%20concert%20atmosphere%2C%20dark%20background%20with%20amber%20highlights%2C%20sophisticated%20Las%20Vegas%20venue%2C%20professional%20photography%2C%20classical%20elegance&width=400&height=400&seq=21&orientation=squarish',
    avatarUrl: 'https://readdy.ai/api/search-image?query=string%20quartet%20musicians%20portrait%2C%20warm%20lighting%2C%20dark%20background%2C%20elegant%20formal%20attire%2C%20professional%20headshot%2C%20Las%20Vegas%20artists%2C%20amber%20golden%20highlights%2C%20professional%20photography%2C%20sophisticated%20expressions&width=200&height=200&seq=22&orientation=squarish',
    featured: true,
    eventTypes: ['Weddings', 'Galas', 'Special Celebrations'],
    phone: '+1 (702) 555-0404',
    email: 'contact@elitequartet.com',
    website: 'https://elitequartet.com',
    social: {
      instagram: '@elitequartet',
      facebook: 'Elite Quartet',
      youtube: 'Elite Quartet',
    },
  },
  {
    id: '5',
    name: 'Soul Fire Quintet',
    category: 'Quintet',
    genre: 'Soul & R&B',
    bio: 'Five musical souls that ignite any dance floor. With roots in Memphis soul and the energy of Las Vegas, every show is a party.',
    imageUrl: 'https://readdy.ai/api/search-image?query=soul%20band%20performing%20on%20stage%20with%20brass%20section%2C%20five%20musicians%20with%20high%20energy%2C%20warm%20golden%20and%20amber%20lighting%2C%20professional%20concert%20atmosphere%2C%20dark%20background%20with%20spectacular%20lights%2C%20Las%20Vegas%20show%20style%2C%20professional%20photography%2C%20dynamic%20performance&width=400&height=400&seq=23&orientation=squarish',
    avatarUrl: 'https://readdy.ai/api/search-image?query=soul%20band%20five%20musicians%20portrait%2C%20warm%20lighting%2C%20dark%20background%2C%20stylish%20casual%20attire%2C%20professional%20headshot%2C%20Las%20Vegas%20artists%2C%20amber%20golden%20highlights%2C%20professional%20photography%2C%20energetic%20expressions&width=200&height=200&seq=24&orientation=squarish',
    featured: true,
    eventTypes: ['Private Parties', 'Corporate Events', 'Special Celebrations'],
    phone: '+1 (702) 555-0505',
    email: 'book@soulfireband.com',
    website: 'https://soulfireband.com',
    social: {
      instagram: '@soulfireband',
      facebook: 'Soul Fire Quintet',
      youtube: 'Soul Fire Band',
    },
  },
  {
    id: '6',
    name: 'Nevada Lights Band',
    category: 'Full Band',
    genre: 'Pop Rock & Latin',
    bio: 'The most requested band in Las Vegas for weddings and corporate events. With 8 members and a repertoire of over 300 songs, they guarantee an unforgettable night.',
    imageUrl: 'https://readdy.ai/api/search-image?query=full%20band%20performing%20on%20Las%20Vegas%20concert%20stage%2C%20large%20ensemble%20with%20drums%20guitars%20keyboards%20and%20vocals%2C%20dramatic%20stage%20lighting%20with%20amber%20and%20gold%2C%20professional%20photography%2C%20dark%20background%20with%20spectacular%20concert%20lights%2C%20high%20energy%20performance%2C%20professional%20musicians&width=400&height=400&seq=25&orientation=squarish',
    avatarUrl: 'https://readdy.ai/api/search-image?query=full%20band%20group%20portrait%2C%20warm%20lighting%2C%20dark%20background%2C%20stylish%20performance%20attire%2C%20professional%20headshot%2C%20Las%20Vegas%20band%2C%20amber%20golden%20highlights%2C%20professional%20photography%2C%20confident%20expressions%2C%20large%20ensemble&width=200&height=200&seq=26&orientation=squarish',
    featured: true,
    eventTypes: ['Weddings', 'Private Parties', 'Special Celebrations', 'Corporate Events'],
    phone: '+1 (702) 555-0606',
    email: 'info@nevadalights.com',
    website: 'https://nevadalights.com',
    social: {
      instagram: '@nevadalightsband',
      facebook: 'Nevada Lights Band',
      youtube: 'Nevada Lights Band',
    },
  },
];